import React from 'react';
import { Calendar, FileText, Send, X } from 'lucide-react';
import { FormField, Input } from "@/components/ui/FormComponents";
import { Button } from "@/components/ui/Button";

export const MaterialRequestFooter = ({
  expectedDate,
  onDateChange,
  notes,
  onNotesChange,
  onClose,
  onSubmit,
  selectedCount,
  submitting,
  assigneeSelected = true,
  allowEmpty = false
}) => {
  return (
    <div className="shrink-0 px-5 sm:px-6 py-4 border-t border-slate-100 bg-white flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col md:flex-row gap-4">
        {/* Polinaidu: 24-04-2026 (20:01) - Using reusable FormField and Input components */}
        <FormField 
          label="Expected Date" 
          icon={Calendar} 
          className="flex-1"
        >
          <Input 
            type="date" 
            value={expectedDate}
            onChange={(e) => onDateChange(e.target.value)}
            id="expected-date-input"
          />
        </FormField>

        <FormField 
          label="Internal Remarks / Notes" 
          icon={FileText} 
          className="flex-[1.5]"
        >
          <Input 
            type="text"
            placeholder="Add specific instructions for logistics..."
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            id="notes-input"
          />
        </FormField>
      </div>

      <div className="flex flex-col-reverse sm:flex-row items-center justify-end gap-3 w-full">
        <Button
          variant="secondary"
          onClick={onClose}
          className="w-full sm:flex-1 h-10 rounded-lg"
          id="cancel-request-btn"
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={(!allowEmpty && selectedCount === 0) || !assigneeSelected}
          loading={submitting}
          className="w-full sm:flex-1 h-10 rounded-lg"
          id="submit-request-btn"
        >
          {submitting ? 'Processing...' : 'Submit Request'}
          {selectedCount > 0 && !submitting && (
            <div className="ml-2 w-5 h-5 rounded-full bg-white/20 flex items-center justify-center text-[10px]">
              {selectedCount}
            </div>
          )}
        </Button>
      </div>
    </div>
  );
};
